import React from 'react'

export const LiveAccessCaptionsIframe = (props) => {
  const { isVisible, url } = props
  const style = {
    border: '1px',
    width: '100%',
    height: '100%',
  }
  return (
    <div>
      {isVisible
        && <div className="live-access-captions__container">
          <iframe
            title="Captions"
            className="tpm-live-asr-embed"
            id="live-asr-embed-28079"
            src={url}
            frameBorder="0"
            style={style}
            allow="fullscreen"
          />
        </div>
      }
    </div>
  )
}

export default LiveAccessCaptionsIframe
